import React from "react";
import { Grid, GridColumn, GridRow } from "sprint-common-web";

import { DeliveryEndpointProvider } from "../../delivery-endpoint/context/DeliveryEndpointProvider";
import { DeliveryEndpointSection } from "../../delivery-endpoint/DeliveryEndpointSection";
import { SystemProvider } from "../../system/context/SystemProvider";
import { SystemSection } from "../../system/listing/SystemSection";
import { IntegratorProvider } from "../context/IntegratorProvider";
import { IntegratorDetailsDashboardHeader } from "../details-header/IntegratorDetailsDashboardHeader";

export const IntegratorDetailsDashboard: React.FC = () => {
    return (
        <>
            <IntegratorProvider>
                <IntegratorDetailsDashboardHeader />
            </IntegratorProvider>
            <Grid>
                <GridRow>
                    <GridColumn sm={12}>
                        <SystemProvider>
                            <SystemSection />
                        </SystemProvider>
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={6}>
                        <DeliveryEndpointProvider>
                            <DeliveryEndpointSection />
                        </DeliveryEndpointProvider>
                    </GridColumn>
                </GridRow>
            </Grid>
        </>
    );
};
